window.onload = function() {

    window.spWhatsAppTrack = function(buttonType){
       if(buttonType == 'widgetButton'){
            if (typeof gtag == 'function') {
                // gtag('event', 'click', { 'event_category': 'telefono', 'event_label': 'whatsapp' });
              gtag('event', 'adw_whatsapp' );
            };

            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'adw_whatsapp' });
            };
           console.log('click in whatsapp');
         
       }
    };
  
    // jQuery is not loaded
    console.log("without jquery load");
    if (typeof ttq == 'object' && typeof ttq.track == 'function'){
      console.log('tiktok pixel ok')
    } else {
      console.log('no tiktok pixel');
    }
    //ttq.track('collection_viewed')

    /**
     * Activacion e incrustación de clases para eventos
     */
    
  /*document.querySelectorAll('a[href^="tel"]').forEach(element => {
        element.classList.add("link-phone");
        element.addEventListener('click', function () {
            if (typeof gtag === "function") {
                gtag("event", "adw_telefono");
            }
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'adw_telefono' });
            }
            if (typeof ttq == 'object' && typeof ttq.track == 'function') {
                ttq.track('Contact', { content_name: 'adw_telefono' });
            }
        })
    });*/
    document.querySelectorAll('a[href^="mailto"]').forEach(element => {
        element.classList.add("link-email");
        element.setAttribute("target", "_blank");
        element.addEventListener('click', function () {
            if (typeof gtag === "function") {
                gtag("event", "adw_email");
            }
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'adw_email' });
            };
        });
    });
    document.querySelectorAll('a[href*="wa.me"]').forEach(element => {
        element.classList.add("link-whatsapp");
        element.setAttribute("target", "_blank");
        element.addEventListener('click', function () {
            if (typeof gtag === "function") {
                gtag("event", "adw_whatsapp");
            }
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'adw_whatsapp' });
            };
        });
    });
    document.querySelectorAll('a[href*="api.whatsapp"]').forEach(element => {
        element.classList.add("link-whatsapp");
        element.setAttribute("target", "_blank");
        element.addEventListener('click', function () {
            if (typeof gtag === "function") {
                gtag("event", "adw_whatsapp");
            }
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'adw_whatsapp' });
            };
           if ( typeof tt == 'function' ) {
             tt('track', 'Contact', { content_name: 'adw_whatsapp' });
             console.log('tiktok whatsapp click')
           } else {
             console.log('no tiktok pixel');
           }
          
        });
    });        
    document.querySelectorAll('a[href*="m.me"]').forEach(element => {
        element.classList.add("link-messenger");
        element.setAttribute("target", "_blank");
        element.addEventListener('click', function () {
            if (typeof gtag === "function") {
                gtag("event", "adw_messenger");
            }
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'adw_messenger' });
            };
        });
    });
    document.querySelectorAll('a[href*="goo.gl"]').forEach(element => {
        element.classList.add("link-map");
        element.setAttribute("target", "_blank");
        element.addEventListener('click', function () {
            if (typeof gtag === "function") {
                gtag("event", "adw_maps");
            }
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'adw_maps' });
            };
        });
    });
};